<template>
  <v-container class="pa-0">
    <v-sheet color="grey lighten-4">
      <v-container >        
        <v-btn icon class="btnRemove" @click="onRemove()"><v-icon>close</v-icon></v-btn>
        <SearchViewBlockItem
          v-for="(search, i) in block.searches"
          :key="search.idx"
          :hasPrev="i>0"
          :aSearch="search"
          :hasAdd="i==block.searches.length-1"
          @add="addSearch()"
          @remove="removeSearch(search.idx)"
          :debug="debug"
          :fLoading="fLoading"
          :isDirty="isDirty"
          @dirty="dirty=true"
        />
      </v-container>
    </v-sheet>
    <div class="text-xs-center">{{ $t('EXTSEARCH_SEARCH_BLOCK_OR') }}</div>
  </v-container>
</template>

<script>
import SearchViewBlockItem from './SearchViewBlockItem'
import { SearchModelBlockItem } from "../models/SearchModel";

export default {
  name: 'SearchViewBlock',
  components: {
    SearchViewBlockItem
  },
  props: ['block', 'debug', 'fLoading', 'isDirty'],
  data() {
    return {
      dirty: false,
    }
  },
  computed: {
    aBlock() {
      return this.block
    }
  },
  watch: {
    isDirty(val) {
// console.log('watch isDirty', val);
      if (!val) {
        this.dirty = false
      }
    },
    dirty(val) {
// console.log('watch dirty', val)
      if (val) {
        this.$emit('dirty')
      }
    },
  },
  methods: {
    onRemove() {
      this.$emit('remove')
    },
    addSearch() {
// console.log('addSearch')
      this.aBlock.searches.push(new SearchModelBlockItem())
      this.dirty = true
    },
    removeSearch(idx) {
// console.log('removeSearch', idx)
      this.aBlock.searches = this.block.searches.filter(a => a.idx != idx)
      if (!this.block.searches.length) {
        this.addSearch()
      }
      this.dirty = true
    },
  }
}
</script>

<style scoped lang="scss">
.btnRemove {
  top: 0;
  left: 0;
  transform: translate(-25%, -25%)
}
.container {
  padding: 12px;
}
</style>
